module.exports = "<div id=\"p\" ></div>\n\n<figure class=\"highcharts-figure\">\n    <div id=\"tempratureRange\"></div>\n</figure>"